module.exports = __webpack_public_path__ + "9bc4a8e78f6787fd6ab2a6631345737e.png";